  query getTotals(
    $clientId: ID
    $projectId: ID
    $productIds: [ID]
    $startDate: AWSDateTime
    $endDate: AWSDateTime
  ) {
    overall: SalesAnalyticsGetTotals(
      startDate: $startDate
      endDate: $endDate
      clientId: $clientId
      projectId: $projectId
      productIds: $productIds
      productView: BUNDLE
    ) {
      quantity
      sales
    }
  }